import React from 'react';
import {useTranslation} from 'react-i18next';

const BreadcrumbOne = ({ title, titleKey, style }) => {
    const { t } = useTranslation();
    const resolvedTitle = titleKey ? t(titleKey) : title;
    return (
        <div className="edu-breadcrumb-area breadcrumb-style-1 ptb--35 ptb_md--40 ptb_sm--40 bg-image" style={style || {}}>
            <div className="container eduvibe-animated-shape">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="breadcrumb-inner text-start">
                            <div className="page-title">
                                {titleKey ? (
                                    <h3 className="title">{resolvedTitle}</h3>
                                ) : (
                                    <h3 className="title" dangerouslySetInnerHTML={{ __html: resolvedTitle }} />
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="shape-dot-wrapper shape-wrapper d-xl-block d-none">
                    <div className="shape-image shape-image-1">
                        <img src="/images/shapes/shape-11-07.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-2">
                        <img src="/images/shapes/shape-01-02.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-3">
                        <img src="/images/shapes/shape-03.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-4">
                        <img src="/images/shapes/shape-13-12.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-5">
                        <img src="/images/shapes/shape-36.png" alt="Shape Thumb" />
                    </div>
                    <div className="shape-image shape-image-6">
                        <img src="/images/shapes/shape-05-07.png" alt="Shape Thumb" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BreadcrumbOne;
